import { Box, Typography, Paper, Grid } from "@mui/material";
import { AirplanemodeActive } from "@mui/icons-material";
import { useTravelPackagesContext } from "@/context/TravelPackagesContext";
import Link from "@/components/link";
import CardImage from "@/components/cardImage";
import { TravelProduct } from "@t3/shared";

export const ShopTravel = () => {
  const { packages } = useTravelPackagesContext();

  return (
    <div data-cypress="shop-travel-page" style={{ marginTop: "10px" }}>
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "24px", sm: "36px", lg: "42px" },
            letterSpacing: "1px",
            color: "black",
            paddingBottom: "10px",
            borderBottom: "2px solid black",
            display: "inline-block",
          }}
        >
          Travel Packages
          <AirplanemodeActive
            sx={{
              fontSize: { xs: "24px", sm: "36px", lg: "42px" },
              color: "black",
              marginLeft: "10px",
            }}
          />
        </Typography>
      </Box>
      <Grid
        data-cypress="travel-packages-grid"
        container
        alignItems="center"
        margin="auto"
        columns={{ xs: 3, sm: 6, md: 9 }}
        sx={{
          marginTop: { xs: false ? "210px" : "20px", sm: "20px" },
          width: { xs: "auto", sm: 560, md: 840, lg: 1140 },
        }}
      >
        {packages && <RenderCards packages={packages} />}
      </Grid>
    </div>
  );
};

const RenderCards = ({ packages }: { packages: TravelProduct[] }) => {
  return packages?.map((p, index) => (
    <Grid key={p.utid} size={{ xs: 3 }}>
      <Link to={`/shop/travel/${p.utid}`}>
        <Paper
          data-cypress={`travel-package-${index}`}
          elevation={2}
          sx={{
            width: { xs: "auto", sm: 260, lg: 360 },
            margin: { xs: "5px 5px", sm: "10px" },
            padding: { xs: "5px 5px", sm: "20px" },
            textAlign: { xs: "left", sm: "center" },
            display: "flex",
            flexDirection: { xs: "row", sm: "column" },
            alignItems: "center",
            position: "relative",
            transition:
              "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.03)",
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <Box
            sx={{
              flex: { xs: "0 0 auto", sm: "1 0 auto" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CardImage
              imageUrl={p.metadata.imageUrls.firebaseImage}
              margin={{ xs: "5px 5px 0 3px", sm: "auto" }}
              width={{ xs: "112px", sm: "200px", lg: "300px" }}
              height={{ xs: "70.555px", sm: "126px", lg: "190px" }}
            />
          </Box>
          <Box
            sx={{
              flex: { xs: 1, sm: "inherit" },
              paddingLeft: { xs: 2, sm: 0 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              overflow: "hidden",
              marginTop: { sm: 2 },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: 16, lg: 18 },
                fontWeight: "bold",
                width: "100%",
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                textAlign: { xs: "left", sm: "center" },
              }}
            >
              {p.metadata.brandName}
            </Typography>
          </Box>
        </Paper>
      </Link>
    </Grid>
  ));
};
